/* @flow */

export const BRIDGE_TIMEOUT = 5000;
export const CHILD_WINDOW_TIMEOUT = 5000;

export const ACK_TIMEOUT = 2000;
export const ACK_TIMEOUT_KNOWN = 10000;
export const RES_TIMEOUT = __TEST__ ? 2000 : -1;
export const RESPONSE_CYCLE_TIME = 500;
